import {getThemeVariable} from "@pg-design/styles-strings";

export const linkPseudoStateUnStyled = `
    &:link,
    &:visited,
    &:hover,
    &:active {
        text-decoration: none;
        color: inherit;
    }
`;

export const asLink = `
    color: ${getThemeVariable("colors.secondary")};
    text-decoration: none;

    &:hover,
    &:focus {
        color: ${getThemeVariable("colors.highlight")};
        text-decoration: underline;
    }
`;
import {getThemeVariable} from "@pg-design/styles-strings";

export const linkPseudoStateUnStyled = `
    &:link,
    &:visited,
    &:hover,
    &:active {
        text-decoration: none;
        color: inherit;
    }
`;

export const asLink = `
    color: ${getThemeVariable("colors.secondary")};
    text-decoration: none;

    &:hover,
    &:focus {
        color: ${getThemeVariable("colors.highlight")};
        text-decoration: underline;
    }
`;
